export const appSettings = {
    unAuthReqRetryCount: 0,
    version: "",
    uploadStatusRetryCount: 10000,
    location: "Chennai,USA,Mexicali,Romania"
}
